export const HIDDEN_UI_CATEGORIES = [
	'annotation',
	'form',
	'redaction',
	'document',
	'rotate',
	'panel-comment',
	'panel-search',
	'tools',
	'selection',
	'history',
	'insert',
	'security',
	'spread',
];
export const DISABLED_CATEGORIES = HIDDEN_UI_CATEGORIES.filter((category) => category !== 'annotation');
